import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: theme.spacings.lg,
  },
  dividerSpacing: {
    paddingVertical: theme.spacings.sm,
  },
  categoryLabel: {
    fontSize: theme.fontSizes.lg,
    marginBottom: theme.spacings.sm,
  },
  categoryList: {
    gap: theme.spacings.sm,
    marginBottom: theme.spacings.lg,
  },
  checkboxWrapper: {
    width: '100%',
    backgroundColor: colors.newUI.therapist.grey20,
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.md,
    borderWidth: 1,
    borderColor: colors.newUI.therapist.grey30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: theme.spacings.lg,
  },
});
